import { Tabs } from "antd";
import GeneralInformation from "./GeneralInformation";
import AccountingInformation from "./AccountingInformation";
import LogisticsInformation from "./LogisticsInformation";

const onChange = (key) => {
  console.log(key);
};

const ProductInfoTabs = ({ form }) => {
  const items = [
    {
      key: "1",
      label: "General Information",
      children: <GeneralInformation form={form} />,
    },
    {
      key: "2",
      label: "Accounting",
      children: <AccountingInformation form={form} />,
    },
    {
      key: "3",
      label: "Logistics",
      children: <LogisticsInformation form={form} />,
    },
  ];

  return <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
};

export default ProductInfoTabs;
